/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/*
query ProjectBreakdownTable_Query(
  $projectId: ID
) {
  viewer {
    id
    actualPersonId
    component(name: "project_breakdown_table")
    ...ProjectBreakdownTable_viewer_2CgS8h
  }
}

fragment ProjectBreakdownTable_viewer_2CgS8h on Viewer {
  permissions
  project(internalId: $projectId) {
    id
    name
    rateCard {
      currency
      id
    }
    tasks(first: 1000000) {
      edges {
        node {
          id
          name
        }
      }
    }
    expenseItems(first: 1000000) {
      edges {
        node {
          id
          name
        }
      }
    }
    allocations(first: 1000000) {
      edges {
        node {
          id
          startYear
          startMonth
          startDay
          endYear
          endMonth
          endDay
        }
      }
    }
    groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: ["PERSON", "TASK", "EXPENSE", "ALLOCATION"]) {
      personId
      taskId
      expenseId
      allocationId
      scopeTotalMinutes
      plannedRevenue
      plannedCost
      plannedRevenueProfit
      plannedRevenueMargin
      allPlannedTimeAndExpenses
      registeredMinutes
      totalActualRevenueRecognition
      actualCost
      actualRevenueProfit
      actualRevenueMargin
      allActualTimeAndExpenses
      forecastTimeToComplete
      totalForecastRevenueToComplete
      forecastCostToComplete
      forecastRevenueProfitToComplete
      forecastRevenueMarginToComplete
      allForecastTimeAndExpensesToComplete
    }
    baselineGroupedFinancialNumbers: groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: ["ROLE", "EXPENSE_CATEGORY"]) {
      roleId
      expenseCategoryId
      baselineMinutes
      baselineTimeAndExpenses
      baselineCost
      baselineProfit
      baselineMargin
      baselineRevenue
    }
    useBaseline
  }
  company {
    id
    currency
    roles(first: 10000) {
      edges {
        node {
          id
          name
        }
      }
    }
    expenseCategories(first: 10000) {
      edges {
        node {
          id
          name
        }
      }
    }
    allPersons(first: 100000) {
      edges {
        node {
          id
          firstName
          lastName
          profilePictureId
        }
      }
    }
  }
}
*/
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId",
            "type": "ID"
        }
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actualPersonId",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "name",
                "value": "project_breakdown_table"
            }
        ],
        "kind": "ScalarField",
        "name": "component",
        "storageKey": "component(name:\"project_breakdown_table\")"
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
    }, v6 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        }
    ], v7 = [
        (v1 /*: any*/),
        (v4 /*: any*/)
    ], v8 = {
        "kind": "Literal",
        "name": "convertToProjectCurrency",
        "value": true
    }, v9 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10000
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ProjectBreakdownTable_Query",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "ProjectBreakdownTable_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ProjectBreakdownTable_Query",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "permissions",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "internalId",
                                    "variableName": "projectId"
                                }
                            ],
                            "concreteType": "ProjectType",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RateCard",
                                    "kind": "LinkedField",
                                    "name": "rateCard",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v1 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "TaskTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "tasks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Task",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v7 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "tasks(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "ExpenseItemTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "expenseItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExpenseItemTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ExpenseItem",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v7 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "expenseItems(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "AllocationTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "allocations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AllocationTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Allocation",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startYear",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startMonth",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "startDay",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "endYear",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "endMonth",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "endDay",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "allocations(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "groupBy",
                                            "value": [
                                                "PERSON",
                                                "TASK",
                                                "EXPENSE",
                                                "ALLOCATION"
                                            ]
                                        }
                                    ],
                                    "concreteType": "FinancialNumbers",
                                    "kind": "LinkedField",
                                    "name": "groupedFinancialNumbers",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "personId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "taskId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "expenseId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "allocationId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "scopeTotalMinutes",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "plannedRevenue",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "plannedCost",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "plannedRevenueProfit",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "plannedRevenueMargin",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "allPlannedTimeAndExpenses",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "registeredMinutes",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalActualRevenueRecognition",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "actualCost",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "actualRevenueProfit",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "actualRevenueMargin",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "allActualTimeAndExpenses",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "forecastTimeToComplete",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalForecastRevenueToComplete",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "forecastCostToComplete",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "forecastRevenueProfitToComplete",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "forecastRevenueMarginToComplete",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "allForecastTimeAndExpensesToComplete",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"PERSON\",\"TASK\",\"EXPENSE\",\"ALLOCATION\"])"
                                },
                                {
                                    "alias": "baselineGroupedFinancialNumbers",
                                    "args": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "groupBy",
                                            "value": [
                                                "ROLE",
                                                "EXPENSE_CATEGORY"
                                            ]
                                        }
                                    ],
                                    "concreteType": "FinancialNumbers",
                                    "kind": "LinkedField",
                                    "name": "groupedFinancialNumbers",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "roleId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "expenseCategoryId",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "baselineMinutes",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "baselineTimeAndExpenses",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "baselineCost",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "baselineProfit",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "baselineMargin",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "baselineRevenue",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"ROLE\",\"EXPENSE_CATEGORY\"])"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useBaseline",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Company",
                            "kind": "LinkedField",
                            "name": "company",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "RoleTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "roles",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoleTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Role",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v7 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "roles(first:10000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v9 /*: any*/),
                                    "concreteType": "ExpenseCategoryTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "expenseCategories",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExpenseCategoryTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ExpenseCategory",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v7 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "expenseCategories(first:10000)"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100000
                                        }
                                    ],
                                    "concreteType": "PersonTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "allPersons",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PersonTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "firstName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "lastName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "profilePictureId",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "allPersons(first:100000)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": null,
            "metadata": {},
            "name": "ProjectBreakdownTable_Query",
            "operationKind": "query",
            "text": "query ProjectBreakdownTable_Query(\n  $projectId: ID\n) {\n  viewer {\n    id\n    actualPersonId\n    component(name: \"project_breakdown_table\")\n    ...ProjectBreakdownTable_viewer_2CgS8h\n  }\n}\n\nfragment ProjectBreakdownTable_viewer_2CgS8h on Viewer {\n  permissions\n  project(internalId: $projectId) {\n    id\n    name\n    rateCard {\n      currency\n      id\n    }\n    tasks(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    expenseItems(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    allocations(first: 1000000) {\n      edges {\n        node {\n          id\n          startYear\n          startMonth\n          startDay\n          endYear\n          endMonth\n          endDay\n        }\n      }\n    }\n    groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: [\"PERSON\", \"TASK\", \"EXPENSE\", \"ALLOCATION\"]) {\n      personId\n      taskId\n      expenseId\n      allocationId\n      scopeTotalMinutes\n      plannedRevenue\n      plannedCost\n      plannedRevenueProfit\n      plannedRevenueMargin\n      allPlannedTimeAndExpenses\n      registeredMinutes\n      totalActualRevenueRecognition\n      actualCost\n      actualRevenueProfit\n      actualRevenueMargin\n      allActualTimeAndExpenses\n      forecastTimeToComplete\n      totalForecastRevenueToComplete\n      forecastCostToComplete\n      forecastRevenueProfitToComplete\n      forecastRevenueMarginToComplete\n      allForecastTimeAndExpensesToComplete\n    }\n    baselineGroupedFinancialNumbers: groupedFinancialNumbers(convertToProjectCurrency: true, groupBy: [\"ROLE\", \"EXPENSE_CATEGORY\"]) {\n      roleId\n      expenseCategoryId\n      baselineMinutes\n      baselineTimeAndExpenses\n      baselineCost\n      baselineProfit\n      baselineMargin\n      baselineRevenue\n    }\n    useBaseline\n  }\n  company {\n    id\n    currency\n    roles(first: 10000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    expenseCategories(first: 10000) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    allPersons(first: 100000) {\n      edges {\n        node {\n          id\n          firstName\n          lastName\n          profilePictureId\n        }\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = '7d5790d6b43a1cb1cefe2e03e09cb4a2';
export default node;
